/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ccsl_Export_Header_Spotting_ListInputs */

const en_ccsl_export_header_spotting_list = /** @type {(inputs: Ccsl_Export_Header_Spotting_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SPOTTING LIST`)
};

const fr_ccsl_export_header_spotting_list = /** @type {(inputs: Ccsl_Export_Header_Spotting_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`LISTE DE REPERAGE`)
};

const de_ccsl_export_header_spotting_list = /** @type {(inputs: Ccsl_Export_Header_Spotting_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SPEKTAKELIST`)
};

const it_ccsl_export_header_spotting_list = /** @type {(inputs: Ccsl_Export_Header_Spotting_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`LISTA DI AVVISTAMENTO`)
};

const ru_ccsl_export_header_spotting_list = /** @type {(inputs: Ccsl_Export_Header_Spotting_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`СПИСОК НАБЛЮДЕНИЙ`)
};

const es_ccsl_export_header_spotting_list = /** @type {(inputs: Ccsl_Export_Header_Spotting_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`LISTA DE AVISTAMIENTO`)
};

const zh_cn2_ccsl_export_header_spotting_list = /** @type {(inputs: Ccsl_Export_Header_Spotting_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`观测清单`)
};

const ja_ccsl_export_header_spotting_list = /** @type {(inputs: Ccsl_Export_Header_Spotting_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`スポッティングリスト`)
};

const hi_ccsl_export_header_spotting_list = /** @type {(inputs: Ccsl_Export_Header_Spotting_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्पॉटिंग सूची`)
};

const pt_pt2_ccsl_export_header_spotting_list = /** @type {(inputs: Ccsl_Export_Header_Spotting_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`LISTA DE AVISTAMENTOS`)
};

/**
* | output |
* | --- |
* | "SPOTTING LIST" |
*
* @param {Ccsl_Export_Header_Spotting_ListInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ccsl_export_header_spotting_list = /** @type {((inputs?: Ccsl_Export_Header_Spotting_ListInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ccsl_Export_Header_Spotting_ListInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_ccsl_export_header_spotting_list(inputs)
	if (locale === "de") return de_ccsl_export_header_spotting_list(inputs)
	if (locale === "it") return it_ccsl_export_header_spotting_list(inputs)
	if (locale === "ru") return ru_ccsl_export_header_spotting_list(inputs)
	if (locale === "es") return es_ccsl_export_header_spotting_list(inputs)
	if (locale === "zh-CN") return zh_cn2_ccsl_export_header_spotting_list(inputs)
	if (locale === "ja") return ja_ccsl_export_header_spotting_list(inputs)
	if (locale === "hi") return hi_ccsl_export_header_spotting_list(inputs)
	if (locale === "pt-PT") return pt_pt2_ccsl_export_header_spotting_list(inputs)
	return en_ccsl_export_header_spotting_list(inputs)
});